import { Heart, Instagram, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF7F2] font-body">
      <div className="max-w-2xl mx-auto px-4 py-12">
        {/* Back Link */}
        <Link 
          to="/pass" 
          className="inline-flex items-center gap-2 text-[#8B2332] hover:text-[#7A1E2B] mb-8 transition-colors"
          data-testid="back-to-pass"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Anmeldung
        </Link>

        <h1 className="font-heading text-4xl text-[#2D2D2D] mb-8">
          Impressum
        </h1>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-[#EFEBE5] space-y-6">
          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              Angaben gemäß § 5 TMG
            </h2>
            <div className="text-[#6B6B6B] space-y-1">
              <p>EDYT & BLOOM UG</p>
              <p>Steglitzer Damm 38</p>
              <p>12169 Berlin</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              Kontakt
            </h2>
            <div className="text-[#6B6B6B] space-y-1">
              <p>Instagram: <a href="https://www.instagram.com/edytandbloom/" target="_blank" rel="noopener noreferrer" className="text-[#8B2332] hover:underline">@edytandbloom</a></p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <div className="text-[#6B6B6B] space-y-1">
              <p>EDYT & BLOOM UG</p>
              <p>Steglitzer Damm 38</p>
              <p>12169 Berlin</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-[#2D2D2D] mb-3">
              Haftungsausschluss
            </h2>
            <p className="text-[#6B6B6B] leading-relaxed text-sm">
              Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. 
              Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir 
              jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 
              TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen 
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch 
              nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu 
              überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
              Tätigkeit hinweisen.
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 px-4 bg-white border-t border-[#EFEBE5]">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2 text-[#6B6B6B]">
              <Heart className="w-4 h-4 text-[#8B2332]" />
              <span className="font-medium text-[#2D2D2D]">EDYT & BLOOM</span>
            </div>
            
            <div className="flex items-center gap-6 text-sm">
              <a 
                href="/impressum" 
                className="text-[#8B2332] font-medium"
              >
                Impressum
              </a>
              <a 
                href="/datenschutz" 
                className="text-[#6B6B6B] hover:text-[#8B2332] transition-colors"
              >
                Datenschutz
              </a>
              <a 
                href="https://www.instagram.com/edytandbloom/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#6B6B6B] hover:text-[#8B2332] transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ImpressumPage;
